import React, { Component } from "react";
import Page from "../../containers/page";
import xIcon from '../../assets/svg/x.svg';

import {
    Container,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    Input,
    FormGroup,
    Label,
    Button,
} from "reactstrap";

import Isvg from "react-inlinesvg";

import { Player, Controls } from '@lottiefiles/react-lottie-player';

import FormBuilder from "../../components/forms/modalFormBuilder";
import { required } from "../../components/forms/validation";
import ErrorModal from '../../components/errorModal';
import InfoModal from '../../components/infoModal';
import ListBuilder from "../../components/listBuilder";
import DeleteModal from "../../components/deleteModal";
import {
    getSearchParams,
    generateSearchLink,
    generateSearchLinkMultiple,
} from "../../helpers/linkHelper";
import { API_ENDPOINT, DOMAINS, getAgeLimit } from "../../constants";
import { formValueSelector, change } from "redux-form"; // ES6
import { connect } from "react-redux";
import ClinicsFilter from "../../components/clinicsFilter";
import UsersFilter from "../../components/usersFilter";
import Image from "../../components/forms/fields/image";
import Zip from "../../components/forms/fields/zip";


import edit from "../../assets/svg/edit.svg";
import garabage from "../../assets/svg/garbage.svg";
import attachInvoice from '../../assets/svg/attach.svg'

import addIcon from "../../assets/svg/add-icon.svg";
import webdocImage from "../../assets/images/webdoc.png";
import teleqImage from "../../assets/images/teleqLogo.png";
import sembleImage from "../../assets/images/semble.webp";
import labPortalenImage from '../../assets/images/Labportalen_logo.png';

import takeCareImage from '../../assets/images/take_care.webp';
import Search from "../../components/search";
import profileUser from "../../assets/images/user.png";
import notification from "../../assets/svg/notification.svg";
import Usage from "../../assets/svg/usage.svg";
import importIcon from '../../assets/svg/import.svg'

import exportIcon from "../../assets/svg/export.svg";
import Checkbox from '../../components/forms/fields/checkbox';
import MainClicGroupFilter from '../../components/mainClinicGroupsFilter';
import striptags from "striptags";

import moment from 'moment';
import DatePicker from '../../components/forms/fields/datePicker';

import { Pie, Bar } from 'react-chartjs-2';
import downloadIcon from '../../assets/svg/download.svg';

import CanvasJSReact from '../../assets/canvasjs.react';
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
import axios from 'axios'
import SelectGroupForTransfer from '../../components/selectGroupForTransfer'
import ListCheckBox from '../../components/forms/fields/listCheckboxFlex';

import Toggle from '../../components/forms/fields/toggle';
import HTML from '../../components/forms/fields/html';
import ConnectedGroupsComponent from "./connectedGroupsComponent";
import SyncEventsFromCF from "./syncEventsFromCF";
import CheckSpecificCaseComponent from "./checkSpecificCaseComponent";

const isValidNumber = (num) => {
    if (typeof num === 'number') return true;
    if (typeof num !== 'string') return false;
    return !isNaN(num) && !isNaN(parseFloat(num));
};


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}


class WebDocSettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0,
            },
            items: [],
            connectedGroups: []


        };


    }

    get = () => {
        this.props.updateMeta(
            this.props.generateSeoTags(this.state, this.props.lang)
        );

        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState
                    ? this.state.params
                    : getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                    })
            ).then((data) => {
                this.setState(
                    {
                        ...data,
                        loading: null,
                    },
                    () => {
                        this.props.updateMeta(
                            this.props.generateSeoTags(this.state, this.props.lang)
                        );
                    }
                );
            });
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState
                    ? this.state.params
                    : getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,

                    })
            ).then((data) => {
                let dataToSet = { ...data }
                if (dataToSet.page || dataToSet.items || dataToSet.total) {
                    dataToSet.loading = null;
                    let checkFilter = '';
                    if (dataToSet.resultFilter) {
                        checkFilter = String(dataToSet.resultFilter)
                        delete dataToSet.resultFilter;
                    }
                    let search = this.props[0].location.search;
                    let serachParams = getSearchParams(search);
                    let searchParamsFilter = '';
                    if (serachParams.filter) {
                        searchParamsFilter = serachParams.filter;
                    }
                    if (searchParamsFilter != checkFilter) {
                        delete dataToSet.page;
                        delete dataToSet.items;
                        delete dataToSet.total;
                        delete dataToSet.loading;
                    }
                }

                this.setState(
                    {
                        ...dataToSet,
                        // loading: null,
                    },
                    () => {
                        this.props.updateMeta(
                            this.props.generateSeoTags(this.state, this.props.lang)
                        );
                    }
                );
            });
        }


        this.getConnectedGroups();
        this.getWebDocSettings();


    };

    getConnectedGroups = () => {
        fetch(API_ENDPOINT + '/data/webDocSettings/connected-groups', {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(parseJSON).then(({ result, status }) => {
            if (result?.length) {
                this.setState({ connectedGroups: result });
            } else {
                this.setState({ connectedGroups: [] });
            }

        })


    }
    getWebDocSettings = () => {

        fetch(API_ENDPOINT + '/data/webDocSettings/settings', {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(parseJSON).then(({ result, status }) => {
            this.setState({ webDocSettings: result });

        })
    };
    toggleCronSync = () => {
        this.setState({ loading: true }, () => {
            fetch(API_ENDPOINT + '/data/webDocSettings/settings/cron-sync/toggle', {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                this.get();
                this.setState({ toggleCronSync: false })
                setTimeout(() => {
                    this.setState({ loading: false });
                }, 500);

            })
        })
    }
    toggleWebDocSync = () => {
        this.setState({ loading: true }, () => {
            fetch(API_ENDPOINT + '/data/webDocSettings/settings/webdoc-sync/toggle', {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                this.get();
                this.setState({ toggleWebDocSync: false })
                setTimeout(() => {
                    this.setState({ loading: false });
                }, 500);

            })
        })
    }


    componentDidMount() {
        if (typeof window !== "undefined") {
            window.scrollTo(0, 0);
        }

        this.get();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState(
                {
                    loading: true,
                },
                () => {
                    this.get();
                }
            );
        }



    }



    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state,
            });
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    [
                        { name: "sortField", value: field },
                        { name: "sortType", value: type },
                    ],
                    false
                )
            );
        }
    };

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0,
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj });
            }
        } else {
            this.props[0].history.push(
                generateSearchLink(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    name,
                    value,
                    restart
                )
            );
        }
    };
    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0,
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });
            }
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    fields,
                    restart
                )
            );
        }
    };



    render() {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, {
                entries: 10,
                page: 0,
            });
        }


        const activeCronSync = this.state.webDocSettings && this.state.webDocSettings.disabledCronSync ? 'inactive' : 'active';
        const activeWebDocSync = this.state.webDocSettings && this.state.webDocSettings.disabledWebDocSync ? 'inactive' : 'active';
        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
                {
                    this.state.loading ?
                        <div className="whole-screen-loader-wrap">
                            <div className="loader-wrap">
                                <Player
                                    autoplay={true}
                                    loop={true}
                                    renderer={'svg'}
                                    src="/lf30_editor_l5cxzdyf.json"
                                    style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                                ></Player>

                            </div>
                        </div>
                        :
                        null
                }

                <Container fluid>

                    <Row>
                        <Col lg="12">

                            <div className="panel">
                                <div className="panel-header clinic-panel-header">
                                    <h5 className="header-component">
                                        {this.props.linksMeta &&
                                            this.props.linksMeta[this.props[0].location.pathname]
                                            ? this.props.linksMeta[this.props[0].location.pathname][
                                            this.props.lang
                                            ]
                                            : ""}{" "}
                                    </h5>{" "}



                                </div>

                                <Row>
                                    <Col lg='8'>
                                        <ListBuilder
                                            lang={this.props.lang}
                                            loading={this.state.loading}
                                            total={this.state.total}
                                            showNumeration={false}
                                            fields={[
                                                { type: "text", name: "indicator", label: "Flag".translate(this.props.lang), allowSort: true, },
                                                { type: "text", name: "action", label: "Action".translate(this.props.lang), allowSort: true, },
                                                { type: "text", name: "tsCreated", label: "Time".translate(this.props.lang), allowSort: true, },
                                                { type: "text", name: "username", label: "Username".translate(this.props.lang), allowSort: true, }

                                            ]}
                                            items={this.state.items.map((item) => {
                                                let styleIndicatorDiv = {};
                                                if (item?.indicator === 'green') {
                                                    styleIndicatorDiv.backgroundColor = '#03c500';
                                                } else if (item?.indicator === 'red') {
                                                    styleIndicatorDiv.backgroundColor = '#dc3545';
                                                }
                                                return {
                                                    ...item,
                                                    tsCreated: item?.time,
                                                    indicator: <div className={`list-builder-indicator`} style={styleIndicatorDiv}></div>
                                                };
                                            })}
                                            rawItems={this.state.items}
                                            // actions={[

                                            // ]}
                                            params={params}
                                            sortField={params.sortField}
                                            sortType={params.sortType}
                                            updateSort={this.updateSort}
                                            updateParams={this.updateParams}
                                            updateMultipleParams={this.updateMultipleParams}
                                        ></ListBuilder>
                                    </Col>

                                    <Col lg='4'>
                                        <div className="webdoc-settings-wrap">
                                            <div className='webdoc-settings-title'>{'WebDoc SETTINGS'.translate(this.props.lang)}</div>
                                            <div className="webdoc-settings-item-wrap">
                                                <div className="webdoc-settings-item">
                                                    <div className={`webdoc-settings-item-indicator-${activeWebDocSync}`}></div>
                                                    <div className="webdoc-settings-item-title">{'WebDoc sync'.translate(this.props.lang)}</div>
                                                </div>
                                                <div className="webdoc-settings-item-action">
                                                    <Button
                                                        color='danger'
                                                        onClick={() => this.setState({ toggleWebDocSync: true })}
                                                    >
                                                        {activeWebDocSync === 'active' ? 'Deactivate' : 'Activate'}
                                                    </Button>
                                                </div>
                                            </div>

                                            <div className="webdoc-settings-item-wrap">
                                                <div className="webdoc-settings-item">
                                                    <div className={`webdoc-settings-item-indicator-${activeCronSync}`}></div>
                                                    <div className="webdoc-settings-item-title">{'WebDoc cron sync'.translate(this.props.lang)}</div>
                                                </div>
                                                <div className="webdoc-settings-item-action">
                                                    <Button
                                                        color='danger'
                                                        onClick={() => this.setState({ toggleCronSync: true })}
                                                        disabled={activeWebDocSync === 'inactive'}
                                                    >
                                                        {activeCronSync === 'active' ? 'Deactivate' : 'Activate'}
                                                    </Button>
                                                </div>
                                            </div>
                                            {/* <div className="webdoc-settings-item-wrap" style={{ marginBottom: 10 }}>
                                                <div className="webdoc-settings-sync-btn">
                                                    <Button
                                                        color='primary'
                                                        onClick={() => {
                                                            this.setState({ syncEventsFromCFModal: true })
                                                        }}
                                                        disabled={activeWebDocSync === 'inactive'}
                                                    >
                                                        {'Sync events from CF'.translate(this.props.lang)}
                                                    </Button>
                                                </div>
                                            </div> */}
                                            {/* <div className="webdoc-settings-item-wrap">
                                                <div className="webdoc-settings-sync-btn">
                                                    <Button
                                                        color='primary'
                                                        onClick={() => {
                                                            this.setState({ checkSpecificCase: true })
                                                        }}
                                                    >
                                                        {'Check specific case'.translate(this.props.lang)}
                                                    </Button>
                                                </div>
                                            </div> */}



                                        </div>
                                        <ConnectedGroupsComponent
                                            {...this.props}
                                            items={this.state.connectedGroups ?? []}
                                            onUpdate={() => {
                                                this.get();
                                            }}
                                        />
                                    </Col>
                                </Row>


                                {
                                    this.state.toggleWebDocSync ?
                                        <DeleteModal
                                            lang={this.props.lang}
                                            isOpen={this.state.toggleWebDocSync}
                                            toggle={() => this.setState({ toggleWebDocSync: null })}
                                            handler={() => {
                                                this.toggleWebDocSync();
                                            }}
                                        >
                                            {'Do you want to ' + (activeWebDocSync === 'active' ? 'deactivate' : 'activate') + ' WebDoc sync?'}
                                        </DeleteModal>
                                        :
                                        null
                                }
                                {
                                    this.state.toggleCronSync ?
                                        <DeleteModal
                                            lang={this.props.lang}
                                            isOpen={this.state.toggleCronSync}
                                            toggle={() => this.setState({ toggleCronSync: null })}
                                            handler={() => {
                                                this.toggleCronSync();
                                            }}
                                        >
                                            {'Do you want to ' + (activeCronSync === 'active' ? 'deactivate' : 'activate') + ' Cron sync?'}
                                        </DeleteModal>
                                        :
                                        null
                                }

                                {
                                    this.state.syncEventsFromCFModal ?
                                        <SyncEventsFromCF
                                            {...this.props}
                                            isOpen={this.state.syncEventsFromCFModal}
                                            toggle={() => this.setState({ syncEventsFromCFModal: false })}
                                            groups={this.state.connectedGroups ?? []}
                                            onUpdate={() => {
                                                this.get();
                                            }}
                                        />
                                        :
                                        null
                                }
                                {
                                    this.state.checkSpecificCase ?
                                        <CheckSpecificCaseComponent
                                            {...this.props}
                                            isOpen={this.state.checkSpecificCase}
                                            toggle={() => this.setState({ checkSpecificCase: false })}
                                            onUpdate={() => {
                                                this.get();
                                            }} />
                                        :
                                        null
                                }


                            </div>
                        </Col>
                    </Row>
                </Container>



            </div >
        );
    }
}

const selector = formValueSelector("modalForm");

export default connect(
    (state) => {
        return {
            // group: selector(state, "group")
        };
    },
    {
        // changeSubgroup: (value) => change("modalForm", "subgroup", value),
    }
)(Page(WebDocSettings));